import React, { Component } from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import { Modal } from "react-bootstrap";
import BackspaceIcon from '@material-ui/icons/Backspace';
import { 
  getAllOutlet,
  GetAllDeHub,
  mainProduct,
  getAllDeHubProduct,
  allSearch,
  actionBookSlot,
  actionBookSlotForDailyEssential 
} from '../../api/apiService';
import { ToastSuccess, ToastError } from "../toast-notification";
import { connect } from 'react-redux';
import { loader } from '../../Actions/index';
import store from '../../store';

const mapStateToProps = (store) => {
  return {
    loaderDisplay: store.loaderDisplay
  }
}

class SlotActiveTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bgColor: "",
      modalShow: false, // modal
      OutletAll: [],
      DeHubAll: [],
      getProduct: [],
      getDeProduct: [],
      selectOutlet: [],
      selectDeHub: [],
      selectFoodItem: [],
      selectDeProduct: [],
      dropMenu: false,
      dropDeHubMenu: false,
      dropFoodMenu: false,
      dropDeProductMenu: false,
      basePrice: '',
      quantity: '',
      dateId: '',
      slotId: '',
      errorMsg: '',
      modalSubmitted: false,
      productFieldToggle: false,
      deProductFieldToggle: false,
      modalType: "food" // "food" or "deProduct"
    }
    this.allOutlet(1);
    this.allDeHub(1);
  }

  /*
  * Modal Show And Hide
  */
  handleModalShowHide = (dId, sId, type = "food") => {
    this.setState({
      selectOutlet: [],
      selectDeHub: [],
      selectFoodItem: [],
      selectDeProduct: [],
      dropMenu: false,
      dropDeHubMenu: false,
      basePrice: '',
      quantity: '',
      dateId: '',
      slotId: '',
      errorMsg: '',
      dropFoodMenu: false,
      dropDeProductMenu: false,
      modalSubmitted: false,
      productFieldToggle: false,
      deProductFieldToggle: false,
      modalType: type
    })
    const status = !this.state.modalShow;
    this.setState({ modalShow: status });
    if (status) {
      this.setState({ dateId: dId, slotId: sId });
    }
  }

  /* ---------------- OUTLETS ---------------- */
  allOutlet = async (pageNo, searchTerm) => {
    try {
      const outlets = await getAllOutlet(pageNo, searchTerm);
      this.setState({ OutletAll: outlets.data.data })
    } catch (ex) {
      console.log(ex);
    }
  }

  allProduct = async (outletId) => {
    store.dispatch(loader(true));
    try {
      const product = await mainProduct(outletId);
      this.setState({ getProduct: product.data.data })
      store.dispatch(loader(false));
    } catch (ex) {
      console.log(ex);
      store.dispatch(loader(false));
    }
  }

  handleClickOutletOption = (e) => {
    this.setState({
      selectOutlet: [e],
      selectValue: [e.outlet_name],
      dropMenu: !this.state.dropMenu,
      selectFoodItem: [],
      productFieldToggle: true
    }, () => {
      this.allProduct(this.state.selectOutlet[0]._id);
    })
  }

  dropdownMenuOpen = () => {
    this.setState({ dropMenu: !this.state.dropMenu, dropFoodMenu: false })
  }

  handleClickFoodOption = (e) => {
    this.setState({ selectFoodItem: [e], dropFoodMenu: !this.state.dropFoodMenu })
  }

  dropdownFoodMenuOpen = () => {
    this.setState({ dropFoodMenu: !this.state.dropFoodMenu, dropMenu: false })
  }

  /* ---------------- DE HUBS ---------------- */
  allDeHub = async (pageNo, searchTerm) => {
    try {
      const hubs = await GetAllDeHub(pageNo, searchTerm);
      this.setState({ DeHubAll: hubs.data.data })
    } catch (ex) {
      console.log(ex);
    }
  }

  allDeProduct = async (hubId) => {
    store.dispatch(loader(true));
    try {
      const product = await getAllDeHubProduct(1, 200, hubId,"","");
      console.log(product);
      this.setState({ getDeProduct: product.data.data })
      store.dispatch(loader(false));
    } catch (ex) {
      console.log(ex);
      store.dispatch(loader(false));
    }
  }

  handleClickDeHubOption = (e) => {
    this.setState({
      selectDeHub: [e],
      dropDeHubMenu: !this.state.dropDeHubMenu,
      selectDeProduct: [],
      deProductFieldToggle: true
    }, () => {
      this.allDeProduct(this.state.selectDeHub[0]._id);
    })
  }

  dropdownDeHubMenuOpen = () => {
    this.setState({ dropDeHubMenu: !this.state.dropDeHubMenu, dropDeProductMenu: false })
  }

  handleClickDeProductOption = (e) => {
    this.setState({ selectDeProduct: [e], dropDeProductMenu: !this.state.dropDeProductMenu })
  }

  dropdownDeProductMenuOpen = () => {
    this.setState({ dropDeProductMenu: !this.state.dropDeProductMenu, dropDeHubMenu: false })
  }

  /* ---------------- COMMON ---------------- */
  handleSetQuantity = (e) => {
    this.setState({ quantity: e.target.value })
  }
  handleSetBasePrice = (e) => {
    this.setState({ basePrice: e.target.value })
  }

  // handleSearch = async (type, txt) => {
  //   let id = type === "product" ? this.state.selectOutlet[0]?._id : undefined;
  //   try {
  //     const search = await allSearch(type, encodeURIComponent(txt.target.value), id);
  //     let dataValue = search.data.data;
  //     if (!dataValue) {
  //       if (type === "outlet") {
  //         this.allOutlet()
  //       } else {
  //         this.allProduct()
  //       }
  //     } else {
  //       if (type === "outlet") {
  //         this.setState({ OutletAll: search.data.data })
  //       } else {
  //         this.setState({ getProduct: search.data.data })
  //       }
  //     }
  //   } catch (ex) {
  //     console.log(ex);
  //   }
  // }
/* ---------------- COMMON SEARCH ---------------- */
handleSearch = async (type, e) => {
  const searchTerm = e.target.value?.trim();

  try {
    if (type === "outlet") {
      // search outlets
      const outlets = await getAllOutlet(1, searchTerm);
      this.setState({ OutletAll: outlets.data.data || [] });
    } else if (type === "hub") {
      // search hubs
      const hubs = await GetAllDeHub(1, searchTerm);
      this.setState({ DeHubAll: hubs.data.data || [] });
    } else if (type === "product") {
      // search products of selected outlet
      const outletId = this.state.selectOutlet[0]?._id;
      const search = await allSearch("product", encodeURIComponent(searchTerm), outletId);
      this.setState({ getProduct: search.data.data || [] });
    } else if (type === "deProduct") {
      // search products of selected hub
      const hubId = this.state.selectDeHub[0]?._id;
      const search = await allSearch("deProduct", encodeURIComponent(searchTerm), hubId);
      this.setState({ getDeProduct: search.data.data || [] });
    }
  } catch (ex) {
    console.log(ex);
  }
};

  /* ---------------- ACTION BOOK SLOT ---------------- */
  handleBookSlot = async () => {
    let data;
    try {
      if (this.state.modalType === "food") {
        data = {
          "dateId": this.state.dateId._id,
          "slotId": this.state.slotId._id,
          "outletId": this.state.selectOutlet[0]._id,
          "productId": this.state.selectFoodItem[0]._id,
          "quantity": this.state.quantity,
          "basePrice": this.state.basePrice
        }
        const bookSlot = await actionBookSlot(data);
        ToastSuccess(bookSlot.data.message)
      } else {
        data = {
          "dateId": this.state.dateId._id,
          "slotId": this.state.slotId._id,
          "outletId": this.state.selectDeHub[0]._id,
          "productId": this.state.selectDeProduct[0]._id,
          "quantity": this.state.quantity,
          "basePrice": this.state.basePrice
        }
        const bookSlot = await actionBookSlotForDailyEssential(data);
        ToastSuccess(bookSlot.data.message)
      }
      this.setState({ modalShow: false });
    } catch (ex) {
      console.log(ex);
      this.setState({ errorMsg: ex.response?.data?.message })
    }
  }

  modalValid = () => {
    let checked = true;
    if (this.state.modalType === "food") {
      if (this.state.selectOutlet.length < 1) return false;
      if (this.state.productFieldToggle && this.state.selectFoodItem.length < 1) return false;
    } else {
      if (this.state.selectDeHub.length < 1) return false;
      if (this.state.deProductFieldToggle && this.state.selectDeProduct.length < 1) return false;
    }
    if (this.state.quantity === "" || this.state.basePrice === "") return false;
    return checked;
  }

  submittedAddFood = () => {
    this.setState({ modalSubmitted: true })
    if (this.modalValid()) {
      this.handleBookSlot()
    }
  }

  render() {
    return (
      <div>
        {/* TABLE LIST (slots) */}
        <table className="table table-hover">
          <thead>
            <tr>
              <th style={{ width: "15%" }}>Slot date</th>
              <th>Slot</th>
            </tr>
          </thead>
          <tbody>
            {this.props.ActData.sort((a, b) => a.slotDate > b.slotDate ? 1 : -1).map(item => {
              return <tr key={item._id}>
                <td><Moment format="DD-MM-yy">{item.slotDate}</Moment></td>
                <td>
                  <table style={{ minWidth: "100%", textAlign: "center" }}>
                    <thead>
                      <tr style={{ color: "GrayText" }}>
                        <th>Name</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Base Price</th>
                        <th>Public/Private<br />(Code)</th>
                        <th>Status</th>
                        <th>Add Food</th>
                        <th>Add DE Product</th>
                      </tr>
                    </thead>
                    <tbody style={{ color: "#000" }}>
                      {item.slots.sort((a, b) => a.slotStartTime > b.slotStartTime ? 1 : -1).map(m => {
                        const currentTime = moment().format('HH:mm');
                        const currentDate = moment().format('YYYY-DD-MM');
                        const SDate = moment(moment(item.slotDate).format('YYYY-DD-MM'));
                        const sTime = moment(moment(m.slotStartTime).format('HH:mm'));
                        const eTime = moment(moment(m.slotEndTime).format('HH:mm'));

                        let statusColor;
                        if (SDate._i === currentDate) {
                          statusColor = eTime._i >= currentTime && sTime._i <= currentTime ? "green" : sTime._i && eTime._i >= currentTime ? "#014F4B" : "red";
                        } else {
                          statusColor = "orange";
                        }

                        let status;
                        if (SDate._i === currentDate) {
                          status = eTime._i >= currentTime && sTime._i <= currentTime ? "Active" : sTime._i && eTime._i >= currentTime ? "Comming today" : "Deactive";
                        } else {
                          status = "Comming soon";
                        }

                        return (
                          <tr key={m._id}>
                            <td><b>{m.name}</b></td>
                            <td><b><Moment format="HH:mm">{m.slotStartTime}</Moment></b></td>
                            <td><b><Moment format="HH:mm">{m.slotEndTime}</Moment></b></td>
                            <td><b>{m.basePrice}</b></td>
                            <td style={{ color: "blue" }}>
                              <b>{m.isPrivate ? <>Private<br /><span style={{ color: "#000" }}>({m.code})</span></> : ""}</b>
                            </td>
                            <td style={{ color: statusColor }}><b>{status}</b></td>
                            <td>
                              {status !== "Active" && status !== "Deactive"
                                ? <button className='btn btn-verify' onClick={() => this.handleModalShowHide(item, m, "food")}>Add Food</button>
                                : <button className='btn btn-verify' disabled>Add Food</button>}
                            </td>
                            <td>
                              {status !== "Active" && status !== "Deactive"
                                ? <button className='btn btn-verify' onClick={() => this.handleModalShowHide(item, m, "deProduct")}>Add DE Product</button>
                                : <button className='btn btn-verify' disabled>Add DE Product</button>}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </td>
              </tr>
            })}
          </tbody>
        </table>

        {/* ------------------- MODAL ------------------- */}
        <Modal
          show={this.state.modalShow}
          onHide={this.handleModalShowHide}
          backdrop="static"
          size="md"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.modalType === "food" ? "Add Food" : "Add DE Product"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className='error-msg'>{this.state.errorMsg}</p>

            {/* OUTLET / DE HUB SELECT */}
            {this.state.modalType === "food" ? (
              // OUTLET SELECT
             <div className="select-box">
                  <div
                    className="options-container"
                    style={this.state.dropMenu ? {} : { display: "none" }}>
                    {this.state.OutletAll.map((item, i) => {
                      return (
                        <div
                          className="option"
                          key={item._id}
                          onClick={() => this.handleClickOutletOption(item)}
                        >
                          <label>{item.outlet_name}</label><br />
                          {/* <div className="d-flex justify-content-between">
                            <div className="para-shot font-12"><b>{item.address_details.address}</b></div>
                            <span>
                              {!item.offer ? "" : <kbd>{item.offer.percentage ? `${item.offer.amount}%` : `₹${item.offer.amount}`}</kbd>}
                            </span>
                          </div> */}
                        </div>
                      );
                    })}
                  </div>
                  <div className="selected"
                    onClick={this.dropdownMenuOpen}
                    style={this.state.selectOutlet < 1 && this.state.modalSubmitted ? { border: "1px solid red", borderRadius: "4px" } : { border: "1px solid #cccccc", borderRadius: "4px" }}
                  >
                    {(this.state.dropMenu && this.state.selectOutlet.length) >= 1 || (!this.state.dropMenu && this.state.selectOutlet.length) >= 1 ? "" : "Select outlets"}
                    {this.state.selectOutlet.map((m, i) => {
                      return <span className="badge bg-warning text-dark mx-1" key={i}>
                        {m.outlet_name}
                      </span>
                    })}
                  </div>
                  <div
                    className="search-box"
                    style={this.state.dropMenu ? {} : { display: "none" }}
                  >
                    <input
                      onChange={(e) => this.handleSearch("outlet", e)}
                      id="myFoodOutlet"
                      type="search"
                      placeholder="Search ..."
                      autoComplete="off"
                    />
                  </div>
                </div>
            ) : (
              // DE HUB SELECT
              
              <div className="category-field mb-2">
                <label className="font-12 m-0">Select DE Hub</label>
                <div className="select-box">
                  <div
                    className="options-container"
                    style={this.state.dropMenu ? {} : { display: "none" }}>
                    {this.state.DeHubAll.map((item, i) => {
                      return (
                        <div
                          className="option"
                          key={item._id}
                          onClick={() => this.handleClickDeHubOption(item)}
                        >
                          <label>{item.hub_name}</label><br />
                          {/* <div className="d-flex justify-content-between">
                            <div className="para-shot font-12"><b>{item.address_details.address}</b></div>
                            <span>
                              {!item.offer ? "" : <kbd>{item.offer.percentage ? `${item.offer.amount}%` : `₹${item.offer.amount}`}</kbd>}
                            </span>
                          </div> */}
                        </div>
                      );
                    })}
                  </div>
                  <div className="selected"
                    onClick={this.dropdownMenuOpen}
                    style={this.state.selectDeHub < 1 && this.state.modalSubmitted ? { border: "1px solid red", borderRadius: "4px" } : { border: "1px solid #cccccc", borderRadius: "4px" }}
                  >
                    {(this.state.dropMenu && this.state.selectDeHub.length) >= 1 || (!this.state.dropMenu && this.state.selectDeHub.length) >= 1 ? "" : "Select hubs"}
                    {this.state.selectDeHub.map((m, i) => {
                      return <span className="badge bg-warning text-dark mx-1" key={i}>
                        {m.hub_name}
                      </span>
                    })}
                  </div>
                  <div
                    className="search-box"
                    style={this.state.dropMenu ? {} : { display: "none" }}
                  >
                    <input
                      onChange={(e) => this.handleSearch("hub", e)}
                      id="myFoodOutlet"
                      type="search"
                      placeholder="Search ..."
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* PRODUCT SELECT */}
            {this.state.modalType === "food" && this.state.productFieldToggle && (
              <div className="category-field">
                <label className="font-12 m-0">Select Food</label>
                <div className="select-box">
                  <div className="options-container" style={this.state.dropFoodMenu ? {} : { display: "none" }}>
                    {this.state.getProduct.map((item, i) => (
                      <div className="option" key={item._id} onClick={() => this.handleClickFoodOption(item)}>
                        <label>{item.product_name}</label>
                      </div>
                    ))}
                  </div>
                  <div className="selected"
                    onClick={this.dropdownFoodMenuOpen}
                    style={this.state.selectFoodItem < 1 && this.state.modalSubmitted ? { border: "1px solid red" } : {}}>
                    {this.state.selectFoodItem.length ? this.state.selectFoodItem[0].product_name : "Select Food"}
                  </div>
                </div>
              </div>
            )}

            {this.state.modalType === "deProduct" && this.state.deProductFieldToggle && (
              <div className="category-field">
                <label className="font-12 m-0">Select DE Product</label>
                <div className="select-box">
                  <div className="options-container" style={this.state.dropDeProductMenu ? {} : { display: "none" }}>
                    {this.state.getDeProduct.map((item, i) => (
                      <div className="option" key={item._id} onClick={() => this.handleClickDeProductOption(item)}>
                        <label>{item.product_name}</label>
                      </div>
                    ))}
                  </div>
                  <div className="selected"
                    onClick={this.dropdownDeProductMenuOpen}
                    style={this.state.selectDeProduct < 1 && this.state.modalSubmitted ? { border: "1px solid red" } : {}}>
                    {this.state.selectDeProduct.length ? this.state.selectDeProduct[0].product_name : "Select DE Product"}
                  </div>
                </div>
              </div>
            )}

            {/* QUANTITY & PRICE */}
            <div className="form-group mb-2">
              <label className="font-12 m-0">Quantity</label>
              <input
                onChange={this.handleSetQuantity}
                value={this.state.quantity}
                type="number"
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label className="font-12 m-0">Base Price</label>
              <input
                onChange={this.handleSetBasePrice}
                value={this.state.basePrice}
                type="number"
                className="form-control"
              />
            </div>

            <div className="text-right my-3">
              <button
                onClick={this.submittedAddFood}
                type="button"
                className="btn btn-verify">Add
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default connect(mapStateToProps)(SlotActiveTable);
